import React, { useContext, useState, useMemo } from 'react';

import GaugeChart from 'react-gauge-chart';
import {
  Grid,
  Button,
  Card,
  Typography,
  CardContent,
  makeStyles,
  Modal, Backdrop, Fade, Accordion, AccordionDetails, AccordionSummary
} from '@material-ui/core';


import UserContext from '../../context/Globales/UserContext';
import TblDetalleConyugeModal from './TblDetalleConyugeModal';
import TblDireccionesModal from './TblDireccionesModal';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Icpdf2EmpresaModal from '../pdf/IC/Icpdf2EmpresaModal';
import Icpdf2PersonaModal from '../pdf/IC/Icpdf2PersonaModal';
//import Grafico2Modal from '../Graficos/Grafico2Modal';
import IndicadoresEmpresasModal from './IndicadoresEmpresasModal'
import TblDetalleConsultasRut from '../Consultainforme/TblDetalleConsultasRut';
import TblDetalleConsultasRutModal from './TblDetalleConsultasRutModal';
import ReactSpeedometer from "react-d3-speedometer"

const useStyles = makeStyles((theme) => ({
  tituloTable: {

    backgroundColor: theme.palette.fondotitulos.main,
    // backgroundImage : `url(${FondoImagenes})`,

    minWidth: 200,
    color: '#171717',
    textAlign: 'center',
    padding: '20px',
    fontWeight: '250',
    fontSize: '35px'
  },
  TituloIdentificacion: {

    backgroundColor: theme.palette.primary.main,
    backgroundImage: `url(${process.env.PUBLIC_URL + '/static/imagen/fondo.jpg'})`,
    minWidth: 200,
    color: 'black',
    textAlign: 'left',
    padding: '15px',
    fontWeight: '450',
    fontSize: '18px',
    height: 'auto',
    alignContent: 'center',
  },
  fondoTituloIndicadores: {

    backgroundColor: theme.palette.fondotitulos.main,

    minWidth: 200,
    textAlign: 'center',
    padding: '15px',
    fontWeight: '300',
    fontSize: '18px',
    height: 'auto',
    alignContent: 'center',
  },

  FondoTable: {

    backgroundColor: theme.palette.greyFondo.main
  },

  imageCliente: {

    borderRadius: '50%',
    width: '100px',
    height: '100px'

  },

  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '50%',
  },

  modaldetalle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    overflow: 'scroll',
    height: '100%',
  },
  paperdetalle: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '50%',
    height: '35%',
    overflow: 'scroll',
  },
  mousePointer: { cursor: 'pointer' },

  colorAlto: {
    backgroundColor: '#EA4228',
  },

  colorMedio: {
    backgroundColor: '#F5CD19',

  },
  colorBajo: {
    backgroundColor: '#5BE12C',
  },

  heading: {
    fontSize: theme.typography.pxToRem(16),
    flexBasis: '33.33%',
    flexShrink: 0,

  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },



}))

const Identificacion = () => {

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState('panel1');
  const { datoICMODAL, DatodetalleconyugeModal, DatodetalleDireccionesModal } = useContext(UserContext);

  const [scoreriesgo, setscoreriesgo] = useState(); // validar resultados cumplimiento/ situacion de riesgo
  const [scorecumplimiento, setscorecumplimiento] = useState();
  const userContext = useContext(UserContext);

  const [OpenMoldaDetalleConyuge, setOpenModalDetalleConyuge] = React.useState(false);
  const [OpenModalDetalleDirecciones, setOpenMOdalDetalleDirecciones] = React.useState(false);
  const scoreDatoModal = JSON.parse(localStorage.getItem('scoreModal'));
  const [ScorePDF, setScorePDF] = useState();

  const [OpenModalpdfImprimir, setOpenModalpdfImprimir] = React.useState(false);



  useMemo(() => {
    const ClasificacionScoreModal = (scor) => {
      let posicion = "";
      switch (scor) {
        case "A":
          posicion = "970";
          break;
        case "B":
          posicion = "790";
          break;
        case "C":
          posicion = "576";
          break;
        case "D":
          posicion = "456";
          break;
        case "E":
          posicion = "242";
          break;
        case "F":
          posicion = "120";
          break;
        case "G":
          posicion = "020";
          break;

        default:
          posicion = "002";
          break;
      }
      return posicion;

    }



    if (datoICMODAL.Clasificacion != "-" && scoreDatoModal == null) {
      const asigdatosScore = ClasificacionScoreModal(datoICMODAL.Clasificacion)

      // console.log('asigdatosScore',asigdatosScore );

      let asigdatoScoreGrafico = asigdatosScore * 100 / 100000

      //  console.log('asigdatosScore',asigdatoScoreGrafico );

      setscoreriesgo(parseFloat(asigdatoScoreGrafico));
      setscorecumplimiento(parseFloat(asigdatoScoreGrafico));
      setScorePDF(asigdatosScore);
      // console.log('scoreriesgo',scoreriesgo);

      //  console.log('scorecumplimiento',scorecumplimiento);

      // backgroundImagedatoICMODAL.DetalleAntecedentesCrediticios[0].Score= ClasificacionScoreModal(datoICMODAL.Clasificacion)

    } else if (scoreDatoModal !== null || scoreDatoModal !== 0) {
      setscoreriesgo((scoreDatoModal) * 100 / 100000);
      setscorecumplimiento((scoreDatoModal) * 100 / 100000);
      setScorePDF(scoreDatoModal);
      //datoICMODAL.DetalleAntecedentesCrediticios.parseInt().Score = ress;

    } else {
      setscoreriesgo(0);
      setscorecumplimiento(0);
      // setScorePDF(0);
    }


  }, [scoreDatoModal, datoICMODAL.Clasificacion])




  const handleChangeAccordeon = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const hanleClickOpenConyuge = () => {
    if (DatodetalleconyugeModal == null || DatodetalleconyugeModal == 'ERROR CONSULTA CONYUGE') {
      setOpenModalDetalleConyuge(true);
      userContext.getDetalleConyugeModal(datoICMODAL.Identificacion?.Rut.replace(/[.]/g, ''), datoICMODAL.ID);
    } else {
      setOpenModalDetalleConyuge(true);
    }

  };

  const hanleClickOpenConyugeCerrar = () => {
    setOpenModalDetalleConyuge(false);
  };

  const hanleClickOpenDirecciones = () => {
    if (DatodetalleDireccionesModal == null || DatodetalleDireccionesModal == 'ERROR CONSULTA DIRECCIONES') {
      setOpenMOdalDetalleDirecciones(true);
      userContext.getDetalleDireccionesModal(datoICMODAL.Identificacion?.Rut.replace(/[.]/g, ''), datoICMODAL.ID);
    } else {
      setOpenMOdalDetalleDirecciones(true);
    }

  };

  const hanleClickOpenDireccionesCerrar = () => {
    setOpenMOdalDetalleDirecciones(false);
  }


  const handleClickPdf = () => {


    setOpenModalpdfImprimir(!OpenModalpdfImprimir);





  }
  const handleClickCerrar = () => {
    setOpenModalpdfImprimir(false)
  }

  // console.log('datoICMODAL.DetalleAntecedentesLaborales',datoICMODAL.DetalleAntecedentesLaborales);
  return (
    <>

      {/*MODAL PDF INFORME COMER*/}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modaldetalle}
        open={OpenModalpdfImprimir}
        onClose={handleClickPdf}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 2000,
        }}>
        <Fade in={OpenModalpdfImprimir}>
          <div className={classes.paperdetalle}>

            {/*<Typography variant="h5" align="right"  onClick={handleClickPdf} className={classes.mousePointer} >X</Typography>/*}
     

       {/** <Icpdf2Empresa />
     <Pdf2 />  <Pdfhtml />   */}
            {datoICMODAL.Identificacion?.IsEmpresa ?
              <Icpdf2EmpresaModal ScorePDF={ScorePDF} />

              : <Icpdf2PersonaModal ScorePDF={ScorePDF} />}
            <br />
            <br />

            <div style={{ alignContent: "center", textAlign: "center" }}>

              <Button variant="contained" color="primary" onClick={handleClickCerrar}>Cerrar</Button>

            </div>


          </div>
        </Fade>
      </Modal>



      {/* Modal detalle conyuge*/}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenMoldaDetalleConyuge}
        onClose={hanleClickOpenConyugeCerrar}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Fade in={OpenMoldaDetalleConyuge}>
          <div className={classes.paper}>

            <Typography variant="h5" align="right" onClick={hanleClickOpenConyugeCerrar} className={classes.mousePointer} >X</Typography>

            <TblDetalleConyugeModal />


          </div>
        </Fade>
      </Modal>

      {/* Modal detalle Direcciones*/}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenModalDetalleDirecciones}
        onClose={hanleClickOpenDireccionesCerrar}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Fade in={OpenModalDetalleDirecciones}>
          <div className={classes.paper}>

            <Typography variant="h5" align="right" onClick={hanleClickOpenDireccionesCerrar} className={classes.mousePointer} >X</Typography>

            <TblDireccionesModal />


          </div>
        </Fade>
      </Modal>
      <br /><br />

      <Grid container justify="space-between" alignItems="baseline" spacing={2}>
        <Grid item xs={12} sm={12} xl={12} md={12} lg={12} >
          <img variant="contained" src={process.env.PUBLIC_URL + '/static/imagen/logonuevoinforme.png'} align="center" width="98%" alt="logo portal cheque" title="logo portal cheque" /><br />
          {/* <img variant="contained" src={process.env.PUBLIC_URL + '/static/imagen/Infcomercial.gif'} align="center" width="50%" alt="logo portal cheque informe comercial" title="logo portal cheque informe comercial" />*/}
          <Typography variant="body2" color="primary" align="right"><strong>Folio:&nbsp;No.{datoICMODAL && datoICMODAL.ID}</strong><br /> Fecha:&nbsp; {datoICMODAL && datoICMODAL.Fecha} - {datoICMODAL && datoICMODAL.Hora}</Typography>
          <Typography variant="body2"></Typography>
        </Grid>


      </Grid>

      <div className={classes.tituloTable}>
      <Typography variant="h5">
        {datoICMODAL.Identificacion?.IsEmpresa ? datoICMODAL.DetalleIdentificacionEmpresa?.Nombre : datoICMODAL.Identificacion?.Nombre}</Typography>

        {/*Empresa*/}
        <div className="container" hidden={datoICMODAL.Identificacion?.IsEmpresa === false} >
          <Typography variant="body2"  ><strong>Rut: &nbsp;</strong>{datoICMODAL.Identificacion?.Rut}</Typography>
          <Typography variant="body2"  ><strong>Rubro: &nbsp;</strong>{datoICMODAL.DetalleIdentificacionEmpresa?.Rubro}</Typography>
          <Typography variant="body2"  ><strong>Disolución Vigente:&nbsp;</strong>{datoICMODAL.Resumenes?.DisolucionVigente?.DisolicionVigente} </Typography>
          <Typography variant="body2"  ><strong>Fecha Disolución:&nbsp;</strong>{datoICMODAL.Resumenes?.DisolucionVigente?.FechaDisolucion}</Typography>
          <Button variant="contained" color="primary" onClick={handleClickPdf}>Imprimir informe</Button>
        </div>
        {/*Persona*/}
        <div className="container" hidden={datoICMODAL.Identificacion?.IsEmpresa === true} >
          <Typography variant="body2"  ><strong>Rut: &nbsp;</strong>{datoICMODAL.Identificacion?.Rut}  </Typography>
          <Typography variant="body2"  ><strong>Fecha Nacimiento: &nbsp;</strong>{datoICMODAL.DetalleIdentificacion?.FechaNacimiento}</Typography>
          <Typography variant="body2"  ><strong>Edad: &nbsp;</strong>{datoICMODAL.DetalleIdentificacion?.Edad}</Typography>
          {datoICMODAL.Resumenes?.BloquedoCedula != null ? <Typography variant="body2"   ><strong>Estado Vigencia cédula: &nbsp;</strong>{datoICMODAL.Resumenes?.BloquedoCedula}</Typography> : ''}
          {datoICMODAL.Resumenes?.BloquedoCedula != null ? <Typography variant="body2"   ><strong>Número Serie: &nbsp;</strong>{datoICMODAL.Resumenes?.NSerie}</Typography> : ''}
          {datoICMODAL.Resumenes?.Defuncion != null ? <Typography variant="body2"   ><strong>Defunción: &nbsp;</strong>{datoICMODAL.Resumenes?.Defuncion}</Typography> : ''}
          <Button variant="contained" color="primary" onClick={handleClickPdf}>Imprimir informe</Button>
        </div>
        {datoICMODAL && datoICMODAL.DetalleIdentificacionEmpresa != null ?
          <div className="container" hidden={datoICMODAL && datoICMODAL.DetalleIdentificacionEmpresa?.DatosExtras?.ExisteInformacionExtra == false}>

            <IndicadoresEmpresasModal />
          </div>
          : ''}
        <hr />
        <Grid container direction="row" spacing={2}>

          <Grid item xs={6} sm={6} xl={6} md={6} lg={6}>

            <div style={{ fontSize: '18px', textAlign: 'center' }}>Situación de Riesgo
        
                  
                  <ReactSpeedometer
              width={220}
              height={200}
              needleHeightRatio={0.6}
              
              value={ScorePDF}
              customSegmentStops={[0, 250, 750, 1000]}
              segmentColors={["#EA4228", "#F5CD19", "#5BE12C"]}
              currentValueText="Situación de Riesgo"
              customSegmentLabels={[
                {
                  text: 'ALTO',
                  position: 'INSIDE',
                  color: '#0d0d0d',
                },
                {
                  text: 'MEDIO',
                  position: 'INSIDE',
                  color: '#0d0d0d',
                },
                {
                  text: 'BAJO',
                  position: 'INSIDE',
                  color: '#0d0d0d',
                },
              ]}
              ringWidth={30}
              needleTransitionDuration={3333}
              needleTransition="easeElastic"
              needleColor={'#0d0d0d'}
              textColor={'#0d0d0d'}
            />
                  
                 </div>


          </Grid>
          <Grid item xs={6} sm={6} xl={6} md={6} lg={6}>


            <div style={{ fontSize: '18px', textAlign: 'center' }}>Cumplimiento
              <GaugeChart id="gauge-chart2"
                nrOfLevels={20}
                colors={["#EA4228", "#F5CD19", "#5BE12C"]}
                percent={scorecumplimiento}
                textColor={'#6b6a6a'}
                hideText={false}
                style={{ fontSize: '20px', fontWeight: 'bold' }}

              />
            </div>

          </Grid>





        </Grid>
      


        <Accordion expanded={expanded === 'panel1'} onChange={handleChangeAccordeon('panel1')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header" >
            <Typography style={{ align: "center" }} ><b>Antecedentes</b></Typography>

          </AccordionSummary>
          <AccordionDetails>
            <Grid
              direction="column"
              container
              justify="center"
              //alignItems="flex-start"
              spacing={2}>


              <Grid style={{ width: '100%' }} item xs={12} sm={12} xl={12} md={12} lg={12} >
                <Card>
                  <div className={classes.fondoTituloIndicadores}> <b>Antecedentes</b></div>

                  <CardContent style={{ textAlign: 'justify' }}>

                    <Typography variant="body2" color="textPrimary"  ><strong>Ultima Dirección registrada: &nbsp;</strong>{datoICMODAL && datoICMODAL.Identificacion?.IsEmpresa ? datoICMODAL && datoICMODAL.DetalleIdentificacionEmpresa?.Direccion : datoICMODAL && datoICMODAL.DetalleIdentificacion?.Direccion}</Typography><hr />
                    <Typography variant="body2" color="textPrimary"  ><strong>Teléfono uno:&nbsp;</strong>{datoICMODAL && datoICMODAL.Identificacion?.IsEmpresa ? datoICMODAL && datoICMODAL.DetalleIdentificacionEmpresa?.CodigoArea + '-' + datoICMODAL && datoICMODAL.DetalleIdentificacionEmpresa?.Telefono : datoICMODAL && datoICMODAL.DetalleIdentificacion?.CodigoArea + '-' + datoICMODAL && datoICMODAL.DetalleIdentificacion?.Telefono} </Typography><hr />
                    <Typography variant="body2" color="textPrimary"  ><strong>Teléfono dos:&nbsp;</strong>{datoICMODAL && datoICMODAL.Identificacion?.IsEmpresa ? datoICMODAL && datoICMODAL.DetalleIdentificacionEmpresa?.CodigoArea2 + '-' + datoICMODAL && datoICMODAL.DetalleIdentificacionEmpresa?.Telefono2 : datoICMODAL && datoICMODAL.DetalleIdentificacion?.CodigoArea2 + '-' + datoICMODAL && datoICMODAL.DetalleIdentificacion?.Telefono2} </Typography><hr />
                    <Typography variant="body2" color="textPrimary"  ><strong>Grupo Socio Económico:&nbsp;</strong>{datoICMODAL && datoICMODAL.DetalleIdentificacion?.GSE ? datoICMODAL && datoICMODAL.DetalleIdentificacion?.GSE : 'NO'}</Typography><hr />
                    {datoICMODAL && datoICMODAL.Identificacion?.IsEmpresa ?
                      <Typography variant="body2" color="textPrimary"  ><strong>Otras Direcciones Registradas:&nbsp;</strong>{datoICMODAL && datoICMODAL.DetalleIdentificacionEmpresa?.IsPoseeDirecciones ? 'SI' + '-' + (`${datoICMODAL && datoICMODAL.DetalleIdentificacionEmpresa?.NumeroDireccionesInformadas}`) : 'NO'} {datoICMODAL && datoICMODAL.DetalleIdentificacionEmpresa?.IsPoseeDirecciones ? <Button variant="outlined" color="primary" onClick={hanleClickOpenDirecciones} >Ver detalle</Button> : ''}</Typography>
                      : <Typography variant="body2" color="textPrimary"  ><strong>Otras Direcciones Registradas:&nbsp;</strong>{datoICMODAL && datoICMODAL.DetalleIdentificacion?.IsPoseeDirecciones ? 'SI' + '-' + (`${datoICMODAL && datoICMODAL.DetalleIdentificacion?.DireccionesInformadas}`) : 'NO'} {datoICMODAL && datoICMODAL.DetalleIdentificacion?.IsPoseeDirecciones ? <Button variant="outlined" color="primary" onClick={hanleClickOpenDirecciones} >Ver detalle</Button> : ''}</Typography>} <hr />
                    {datoICMODAL && !datoICMODAL.Identificacion?.IsEmpresa ? <Typography variant="body2" color="textPrimary"  ><strong>Cónyuge:&nbsp;</strong> {datoICMODAL && datoICMODAL.DetalleIdentificacion?.IsPoseeConyuge ? 'SI' : 'NO'}  {datoICMODAL && datoICMODAL.DetalleIdentificacion?.IsPoseeConyuge ? <Button variant="outlined" color="primary" onClick={hanleClickOpenConyuge} style={{ float: 'right' }}  >Ver detalle</Button> : ''}  </Typography> : ''}

                  </CardContent>
                </Card>

              </Grid>


            </Grid>

          </AccordionDetails>
        </Accordion>


        <Accordion expanded={expanded === 'panel2'} onChange={handleChangeAccordeon('panel2')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header" >
            <Typography style={{ align: "center" }} ><b> Antecedentes Laborales </b></Typography>

          </AccordionSummary>
          <AccordionDetails>
            <Grid
              direction="column"
              container
              justify="center"
              //alignItems="flex-start"
              spacing={2}>



              <Grid style={{ width: '100%' }} item xs={12} sm={12} xl={12} md={12} lg={12} >
                <Card>
                  <div className={classes.fondoTituloIndicadores}><b> Antecedentes Laborales </b></div>
                  <CardContent style={{ textAlign: 'justify' }} >

                    <Typography variant="body2" color="textPrimary" ><strong>Actividad Profesional: &nbsp;</strong> {datoICMODAL && datoICMODAL.DetalleAntecedentesLaborales?.length > 0 ? datoICMODAL && datoICMODAL.DetalleAntecedentesLaborales[0].ActividadProfesional : 'NO REGISTRA'}</Typography><hr />
                    <Typography variant="body2" color="textPrimary" ><strong>Razón Social:&nbsp;</strong>{datoICMODAL && datoICMODAL.DetalleAntecedentesLaborales?.length > 0 ? datoICMODAL && datoICMODAL.DetalleAntecedentesLaborales[0].RazonSocialEmpresa : 'NO REGISTRA'}</Typography><hr />
                    <Typography variant="body2" color="textPrimary"  ><strong>RUT Empresa:&nbsp;</strong>{datoICMODAL && datoICMODAL.DetalleAntecedentesLaborales?.length > 0 ? datoICMODAL && datoICMODAL.DetalleAntecedentesLaborales[0].RutEmpresa : 'NO REGISTRA'}</Typography><hr />
                    <Typography variant="body2" color="textPrimary"  ><strong>Direcciones:&nbsp;</strong>{datoICMODAL && datoICMODAL.DetalleAntecedentesLaborales?.length > 0 ? datoICMODAL && datoICMODAL.DetalleAntecedentesLaborales[0].Direccion : 'NO REGISTRA'}</Typography><hr />
                    <Typography variant="body2" color="textPrimary"  ><strong>Teléfonos:&nbsp;</strong> {datoICMODAL && datoICMODAL.DetalleAntecedentesLaborales?.length > 0 ? datoICMODAL && datoICMODAL.DetalleAntecedentesLaborales[0].Telefono : 'NO REGISTRA'}</Typography><hr />
                  </CardContent>
                </Card>

              </Grid>

            </Grid>

          </AccordionDetails>
        </Accordion>


        <Accordion expanded={expanded === 'panel3'} onChange={handleChangeAccordeon('panel3')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header" >
            <Typography style={{ align: "center" }} ><b> Consultas al Rut ({datoICMODAL && datoICMODAL.DetallesConsultasRut?.NumeroConsultas}) últimos 6 meses </b></Typography>

          </AccordionSummary>
          <AccordionDetails>
            <Grid
              direction="column"
              container
              justify="center"
              //alignItems="flex-start"
              spacing={2}>



              <Grid style={{ width: '100%' }} item xs={12} sm={12} xl={12} md={12} lg={12} >
                <TblDetalleConsultasRutModal />

              </Grid>

            </Grid>

          </AccordionDetails>
        </Accordion>
      </div>








      <CardContent>


      </CardContent>




    </>
  )
}

export default Identificacion
